import { appConfig } from "@/constants";
import { trackEvent } from "@analytics";
import {
  Body,
  Box,
  ButtCon,
  Button,
  Caption,
  Heading,
  Icon,
  Stack,
} from "@biom3/react";
import Image from "next/image";
import { useCallback, useEffect, useMemo, useState } from "react";

const LOGO_URL = `${appConfig.ASSET_BASE_URL}/images/balances/dante-logo.svg`;
const BG_URL = `${appConfig.ASSET_BASE_URL}/images/balances/dante-bg.png`;
const BUY_TOKEN_URL = "https://www.mexc.com/exchange/DANTE_USDT";

export function HellmasterTokenBanner() {
  const [isMounted, setIsMounted] = useState(false);
  const [isBannerClosed, setIsBannerClosed] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleClose = useCallback(() => {
    trackEvent({
      component: "Button",
      action: "Pressed",
      extras: {
        control: "Close",
        section: "GamePageBuyTokenBanner",
        gameId: "ecd70429-fec4-4a00-a0dd-9c236c2cea69",
        gameName: "HellMaster",
      },
    });
    setIsBannerClosed(true);
    localStorage.setItem("showHellmasterBanner", "false");
  }, []);

  const handleExternalLink = useCallback(() => {
    trackEvent({
      component: "Button",
      action: "Pressed",
      extras: {
        control: "BuyOnMEXC",
        section: "GamePageBuyTokenBanner",
        gameId: "ecd70429-fec4-4a00-a0dd-9c236c2cea69",
        gameName: "HellMaster",
      },
    });
    window.open(BUY_TOKEN_URL, "_blank");
  }, []);

  const showBanner = useMemo(() => {
    if (!isMounted) {
      return false;
    }
    if (isBannerClosed) {
      return false;
    }
    if (localStorage.getItem("showHellmasterBanner") === "false") {
      return false;
    }
    return true;
  }, [isMounted, isBannerClosed]);

  if (!showBanner) {
    return null;
  }

  return (
    <Box
      sx={{
        pb: "base.spacing.x2",
        position: "relative",
        borderRadius: "base.spacing.x2",
        mb: "base.spacing.x4",
        overflow: "hidden",
        backgroundImage: `url("${BG_URL}")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          p: "base.spacing.x8",
          zIndex: 1,
          position: "relative",
          paddingX: "base.spacing.x12",
        }}
      >
        <Stack
          direction={["column", "column", "row"]}
          flexWrap="wrap"
          alignItems="center"
          justifyContent="space-between"
          gap="base.spacing.x6"
        >
          <Stack
            sx={{
              alignItems: ["center", "center", "flex-start"],
              textAlign: ["center", "center", "left"],
              flex: 1,
              minWidth: ["auto", "auto", "350px"],
              gap: "base.spacing.x6",
            }}
          >
            <Box>
              <Box>
                <Caption size="small" sx={{ fontWeight: "bold" }}>
                  HELLMASTER
                </Caption>
                <Heading size="medium" weight="bold">
                  $DANTE token is live
                </Heading>
              </Box>
              <Body
                size="xSmall"
                weight="regular"
                sx={{ color: "base.color.text.body.secondary" }}
              >
                Dive deep into the infernal economy with $DANTE, the official
                currency powering the Hellmaster universe.
              </Body>
            </Box>

            <Box
              sx={{
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Image
                src={LOGO_URL}
                width={32}
                height={32}
                alt="DANTE Token"
                style={{
                  objectFit: "contain",
                }}
              />
            </Box>
          </Stack>

          <Stack direction="row" alignItems="center">
            <Button
              variant="primary"
              size="medium"
              onClick={handleExternalLink}
            >
              <Stack direction="row" alignItems="center" gap="base.spacing.x2">
                Buy on MEXC
                <Icon
                  icon="JumpTo"
                  sx={{
                    textAlign: "center",
                    fill: "inherit",
                    w: "base.icon.size.200",
                  }}
                  variant="bold"
                />
              </Stack>
            </Button>
          </Stack>
        </Stack>

        <ButtCon
          icon="Close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: [
              "base.spacing.x4",
              "base.spacing.x4",
              "base.spacing.x4",
              "base.spacing.x4",
              "base.spacing.x4",
              "base.spacing.x2",
            ],
            right: ["base.spacing.x2", "base.spacing.x4"],
            backgroundColor: "base.color.neutral.700",
            "&:hover": {
              backgroundColor: "base.color.neutral.800",
            },
          }}
          variant="tertiary"
          size="small"
        />
      </Box>
    </Box>
  );
}
